import { render, staticRenderFns } from "./selectable-item.vue?vue&type=template&id=ed775408&scoped=true&lang=html"
import script from "./selectable-item.vue?vue&type=script&lang=js"
export * from "./selectable-item.vue?vue&type=script&lang=js"
import style0 from "./selectable-item.vue?vue&type=style&index=0&id=ed775408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed775408",
  null
  
)

export default component.exports